import * as ReactSelect from '@radix-ui/react-select';
import type { SelectProps } from '@radix-ui/react-select';

export type { SelectProps } from '@radix-ui/react-select';

import IconChevronDown from '@/assets/icons/chevron-down.svg?react';

export default function Select({ children, ...props }: SelectProps) {
  return (
    <ReactSelect.Root {...props}>
      <ReactSelect.Trigger className="inline-flex h-9 w-full items-center justify-between gap-1.5 rounded border border-gray-200 bg-white px-4 text-sm leading-none text-gray-900 outline-none hover:bg-gray-50 focus-visible:ring-2 focus-visible:ring-blue-1 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700">
        <ReactSelect.Value />
        <ReactSelect.Icon className="min-w-6 text-gray-500 dark:text-gray-400">
          <IconChevronDown />
        </ReactSelect.Icon>
      </ReactSelect.Trigger>
      <ReactSelect.Portal>
        <ReactSelect.Content className="overflow-hidden rounded-md bg-white shadow-2xl dark:bg-gray-800 dark:text-gray-100">
          <ReactSelect.Viewport className="p-[5px]">
            <ReactSelect.Group>
              {children}
            </ReactSelect.Group>
          </ReactSelect.Viewport>
        </ReactSelect.Content>
      </ReactSelect.Portal>
    </ReactSelect.Root>
  );
}

